<template>
  <a-layout :style="{display: 'inline-block', 'min-width': '100%'}">
    <a-layout-header style="background: #fff; padding: 0">
      <span
        v-if="board && !isEditingTitle"
        v-text="board.boardName"
        class="board-name"
        >
        {{ board.boardName }}
      </span>

      <a-input
        v-if="isEditingTitle"
        v-model="boardName"
        class="title-edit-input"
        :ref="'titleEditingInput'"
        @pressEnter="isEditingTitle=false;"
        />
      <a-button
        v-if="isEditingTitle"
        type="primary"
        class="title-edit-done-button"
        :disabled="boardName.length === 0"
        @click="isEditingTitle=false;"
        >
        Done
      </a-button>

      <div class="button-group-right">

        <a-button-group>

          <a-dropdown :trigger="['click']">
            <a-menu slot="overlay">
              <a-menu-item key="1" @click="startEditingTitle()">
                <a-icon type="font-size" /> Set board name
              </a-menu-item>
              <a-menu-item key="2" @click="showDeleteConfirm()">
                <a-icon type="delete" /> Delete board
              </a-menu-item>
            </a-menu>
            <a-button style="opacity: 0.5" icon="setting" />
          </a-dropdown>

        </a-button-group>

      </div>

    </a-layout-header>

    <a-layout-content>
      <div v-if="board">

        <TaskRow
          v-for="row in board.rows"
          :key="row.id"
          :id="row.id"
          :taskLists="row.taskLists"
          @rowUpdated="onBoardChanged()"
          @removeRow="removeRow($event)"
          ></TaskRow>

      <div
        :bordered="false"
        :class="{'nextRow': true}"
        @click="onPlusClick"
        >
          <div :class="{'nextRowIcon': true}">
            <a-icon type="plus"/>
          </div>
        </div>

      </div>

    </a-layout-content>
  </a-layout>
</template>

<script>
import TaskRow from '@/components/TaskRow';
import { shortId } from '@/utils';
import { debounce } from 'debounce';

export default {
  name: "Board",
  props: ["boardId"],
  components: {
    TaskRow
  },
  computed: {
    board() {
      return this.$store.getters["boards/getBoardById"](this.boardId);
    },
    boardName: {
      get() {
        return this.board.boardName;
      },
      set(value) {
        this.$store.commit(
          'boards/editBoard',
          {board: this.board, key: "boardName", value: value},
        );
        this.onBoardChanged();
      }
    }
  },
  data() {
    return {
      isEditingTitle: false,
    }
  },
  created() {
    // one debounce function per board instance!
    this.saveBoardDebounced = debounce(this.saveBoard, 3000);
  },
  methods: {
    addNewRow(position) {
      const newRow = {id: shortId(), taskLists: [
        {id: shortId(), title: "", extra: "", tasks: []}
      ]};
      this.$store.commit(
        'boards/addRow',
        {rows: this.board.rows, position, row: newRow},
      );
      this.onBoardChanged();
    },
    removeRow(event) {
      this.$store.commit(
        'boards/removeRow',
        {rows: this.board.rows, id: event.id},
      );
      this.onBoardChanged();
    },

    deleteBoard() {
      console.log("deleteBoard", this.boardId)
      this.$store
        .dispatch('boards/deleteBoard', {id: this.boardId})
        .then(() => this.$router.push({name: 'planner'}))
        .catch(function(error) {console.error("Error", error)})
        ;
    },
    saveBoard() {
      this.$store.dispatch(
        'boards/saveBoard',
        {id: this.boardId, board: this.board},
      );
    },

    onBoardChanged() {
      // console.log("onBoardChanged");
      this.saveBoardDebounced();
    },
    onPlusClick() {
      this.addNewRow(this.board.rows.length);
      this.onBoardChanged();
    },

    startEditingTitle() {
      this.isEditingTitle = true;
      this.$nextTick(() => {
        this.$refs.titleEditingInput.focus()
      });
    },
    showDeleteConfirm() {
      this.$confirm({
        title: 'Are you sure to delete this board?',
        content: 'This action can not be undone!',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.deleteBoard();
        },
        onCancel() {},
      });
    },
  },
}
</script>

<style scoped>

.board-name {
  margin-left: 15px;
  color: rgba(0, 0, 0, 0.55);
  display: flex;
  float: left;
  font-size: 1.5em;
}

.button-group-right {
  float: right;
  margin-right: 15px;
}

.nextRow {
  background-color: white;
  cursor: pointer;
  margin-bottom: 15px;
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 15px;
  opacity: .2;
  height: 25px;
  min-width: 250px;
  max-width: 350px;
}

.nextRow:hover {
  opacity: .5;
}

.nextRowIcon {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
}

.title-edit-input {
  width: 300px;
  display: flex;
  float: left;
  margin-top: 16px;
  margin-left: 15px;
}

.title-edit-done-button {
  margin-left: 15px;
}

</style>
